import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ServiceplanFormComponent } from './serviceplan-form.component';

const routes: Routes = [ { path: '', component: ServiceplanFormComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ServiceplanFormRoutingModule { }
